import React, { useState } from "react";
import "./ClientInHandUpdateModal.css";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
// import "./Community.css";

const ClientInHandUpdateModal = ({ data, onClose }) => {
  const [clientInHandData, setClientInHandData] = useState({
    prefferredLocalities: data?.prefferredLocalities || "",
    minBudget: data?.minBudget?.toString() || "",
    maxBudget: data?.maxBudget?.toString() || "",
    floor: data?.floor || "",
    minBhk: data?.minBhk || "",
    maxBhk: data?.maxBhk || "",
    priceUnit: data?.priceUnit || "",
    minArea: data?.minArea || "",
    maxArea: data?.maxArea || "",
    areaUnit: data?.areaUnit || "",
    requirement: data?.requirement || "",
  });

  const handleUpdateClientInHand = async (e) => {
    e?.preventDefault();
    if (
      !clientInHandData.prefferredLocalities ||
      !clientInHandData?.minBudget ||
      !clientInHandData?.maxBudget ||
      // !clientInHandData?.floor ||
      // !clientInHandData?.minBhk ||
      // !clientInHandData?.maxBhk ||
      !clientInHandData?.priceUnit ||
      !clientInHandData?.minArea ||
      !clientInHandData?.maxArea ||
      !clientInHandData?.areaUnit ||
      !clientInHandData?.requirement
    ) {
      toast?.error("Please fill All mandetory Fields!");
      return;
    }
    if (
      Number(clientInHandData?.minBudget) > Number(clientInHandData?.maxBudget)
    ) {
      toast?.error("Min Budget cannot be greater than Max Budget");
      return;
    }
    if (Number(clientInHandData?.minArea) > Number(clientInHandData?.maxArea)) {
      toast.error("Min Area Cannot be greater than Max Area");
      return;
    }

    if (Number(clientInHandData?.minBhk) > Number(clientInHandData?.maxBhk)) {
      toast.error("Min BHK Cannot be greater than Max BHK");
      return;
    }

    try {
      const res = await HomeService.updateClientInHand(data?._id, {
        ...clientInHandData,
        minBudget: Number(clientInHandData?.minBudget),
        maxBudget: Number(clientInHandData?.maxBudget),
      });
      if (res?.status) {
        toast?.success(res?.message);
        onClose();
      } else {
        toast?.error(res?.message);
      }
      console.log("update", res);
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="handleoverflow">
        <div className="modal-container">
          <div className="modal-header">
            <h3>Update Client In Hand </h3>
            <button className="close-btn" onClick={onClose}>
              &times;
            </button>
          </div>

          <div className="modal-body">
            {/* Dropdown Field */}

            {/* Input Field */}
            <div className="form-group">
              <label htmlFor="client-remarks" className="requiredStar">
                Preferred Localities
              </label>
              <input
                value={clientInHandData?.prefferredLocalities}
                onChange={(e) => {
                  setClientInHandData((prev) => ({
                    ...prev,
                    prefferredLocalities: e?.target?.value,
                  }));
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Prefered Locality ..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Min Budget
              </label>
              <input
                value={clientInHandData?.minBudget}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setClientInHandData((prev) => ({
                      ...prev,
                      minBudget: e.target.value,
                    }));
                  }
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Min Budget ..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Max Budget
              </label>
              <input
                value={clientInHandData?.maxBudget}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setClientInHandData((prev) => ({
                      ...prev,
                      maxBudget: e.target.value,
                    }));
                  }
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Max Budget  ..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Price Unit
              </label>
              <select
                value={clientInHandData?.priceUnit}
                onChange={(e) => {
                  setClientInHandData((prev) => ({
                    ...prev,
                    priceUnit: e?.target?.value,
                  }));
                }}
                id="client-status"
                className="modal-select"
                style={{ width: "100%" }}
              >
                <option value="">Select an option</option>
                <option value="TH">Thousand</option>
                <option value="LKH">Lakh</option>
                <option value="CR">Crore</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Min Area
              </label>
              <input
                value={clientInHandData?.minArea}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setClientInHandData((prev) => ({
                      ...prev,
                      minArea: e.target.value,
                    }));
                  }
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Min Area..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Max Area
              </label>
              <input
                value={clientInHandData?.maxArea}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setClientInHandData((prev) => ({
                      ...prev,
                      maxArea: e.target.value,
                    }));
                  }
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Max Area..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Area Unit
              </label>
              <select
                value={clientInHandData?.areaUnit}
                onChange={(e) => {
                  setClientInHandData((prev) => ({
                    ...prev,
                    areaUnit: e?.target?.value,
                  }));
                }}
                id="client-status"
                className="modal-select"
                // style={{ width: "100%" }}
              >
                <option value="">Select an option</option>
                <option value="Feet">Feet</option>
                <option value="Yard">Yard</option>
                <option value="Meter">Meter</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="client-status">Floor</label>
              <input
                value={clientInHandData?.floor}
                onChange={(e) => {
                  setClientInHandData((prev) => ({
                    ...prev,
                    floor: e?.target?.value,
                  }));
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Floor..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status">Min BHK</label>
              <input
                value={clientInHandData?.minBhk}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setClientInHandData((prev) => ({
                      ...prev,
                      minBhk: e.target.value,
                    }));
                  }
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Min BHK..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status">Max BHK</label>
              <input
                value={clientInHandData?.maxBhk}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setClientInHandData((prev) => ({
                      ...prev,
                      maxBhk: e.target.value,
                    }));
                  }
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Max BHK..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="client-status" className="requiredStar">
                Requirment
              </label>
              <textarea
                value={clientInHandData?.requirement}
                onChange={(e) => {
                  setClientInHandData((prev) => ({
                    ...prev,
                    requirement: e?.target?.value,
                  }));
                }}
                type="text"
                id="client-remarks"
                className="modal-input"
                placeholder="Enter Requirment..."
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn-update"
              onClick={(e) => {
                handleUpdateClientInHand(e);
              }}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientInHandUpdateModal;
